var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2811 16.1151L17.8784 8.5178C19.7451 6.65107 20.0205 3.58001 18.2539 1.61822C17.8114 1.12541 17.2732 0.727915 16.672 0.449997C16.0708 0.17208 15.4193 0.0195663 14.7572 0.00176204C14.0951 -0.0160422 13.4364 0.101236 12.8211 0.346442C12.2058 0.591647 11.647 0.959637 11.1786 1.42796L9.75068 2.85591L8.5178 1.62302C6.65107 -0.243716 3.58001 -0.519123 1.61822 1.24744C1.12541 1.68993 0.727915 2.2282 0.449997 2.82939C0.17208 3.43058 0.0195663 4.08209 0.00176204 4.74417C-0.0160422 5.40626 0.101236 6.06502 0.346442 6.68028C0.591647 7.29554 0.959637 7.85439 1.42796 8.32273L9.22032 16.1151C9.36098 16.2558 9.55176 16.3348 9.75069 16.3348C9.94961 16.3348 10.1404 16.2558 10.2811 16.1151Z",
    fill: "#D5D5D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.d47e2017e6887c68e147408eda71060c.svg";
export { ForwardRef as ReactComponent };